import { Trash2 } from "lucide-react";
import React, { useEffect, useState } from "react";
import { useForm, useFieldArray } from "react-hook-form";
import api from "../../lib/api";

const getTodayDate = () => new Date().toISOString().split("T")[0];
const dateToEpoch = (dateStr) => Math.floor(new Date(dateStr).getTime() / 1000);

const priorityOptions = [
  { value: "low", label: "Low" },
  { value: "medium", label: "Medium" },
  { value: "high", label: "High" },
  { value: "urgent", label: "Urgent" },
];

export const TaskEntryForm = ({ onSubmit, isLoading, showEmployeeField, onProjectSelect, }) => {
  const {
    register,
    control,// may be used later
    handleSubmit,
    reset,// may be used later
    formState: { errors },
  } = useForm({
    defaultValues: {
      tasks: [
        {
          title: "",
          description: "",
          assignedBy: "",
          assignedTo: "",
          startDate: getTodayDate(),
          endDate: getTodayDate(),
          status: "",
          priority: "",
          createdBy: "68c15ce1855dbd716909c257",
          project_id: "",       
         },
      ],
    },
  });

  const { fields, append, remove } = useFieldArray({ control, name: "tasks" });
  const [employees, setEmployees] = useState([]);
  const [projects, setProjects] = useState([]);
  // const [selectedProjectId, setSelectedProjectId] = useState("");
  
  useEffect(() => {
    let isMounted = true;
    const fetchEmployees = async () => {
      try {
        const res = await api.get("/employees");
        if (isMounted) setEmployees(res.data.data.employees);
      } catch (err) {
        console.error(err);
      }
    };
    fetchEmployees();
    return () => { isMounted = false };
  }, []);
  
  // ✅ commit: fetch projects list from API
  useEffect(() => {
    let isMounted = true;
    const fetchProjects = async () => {
      try {
        const res = await api.get("/projects");
        if (isMounted && res.data?.data) setProjects(res.data.data);
      } catch (err) {
        console.error("Error fetching projects:", err);
      }
    };
    fetchProjects();
    return () => {
      isMounted = false;
    };
  }, []);


  const handleFormSubmit = (data) => {
    const formattedData = {
      tasks: data.tasks.map((task) => ({
        ...task,
        startDate: dateToEpoch(task.startDate),
        endDate: dateToEpoch(task.endDate),
      })),
    };
    onSubmit(formattedData);
      reset({
      tasks: [
        {
          title: "",
          description: "",
          assignedBy: "",
          assignedTo: "",
          startDate: getTodayDate(),
          endDate: getTodayDate(),
          status: "",
          priority: "",
          createdBy: "68c15ce1855dbd716909c257",
          project_id: "",         
        },
      ],
    });
    // setSelectedProjectId(""); // reset selected project
    onProjectSelect?.(""); // notify parent
  };
  
  // const handleProjectChange = (value) => {
  //   // setSelectedProjectId(value);
  //   onProjectSelect?.(value); // send selected project ID to parent
  // };

  return (
    <form
      onSubmit={handleSubmit(handleFormSubmit)}
      className="bg-white rounded-lg shadow-sm border p-4 ml-3 overflow-x-auto"
    >
      <div className="min-w-[1200px]">
        {/* Header */}
        <div className="hidden md:flex mb-2 text-sm font-medium text-gray-600">
          <div className="w-[15%]">Title</div>
          <div className="flex-1 min-w-[250px]">Description</div>
          <div className="w-[13%]">Project</div>
          <div className="w-[12%]">Assign By</div>
          {showEmployeeField && <div className="w-[12%]">Assign To</div>}
          <div className="w-[8%]">Priority</div>
          <div className="w-[10%]">Status</div>
          <div className="w-[10%]">Start Date</div>
          <div className="w-[10%]">End Date</div>
          <div className="w-[7%] text-center">Action</div>
        </div>

        {/* Rows */}
        <div className="space-y-6">
          {fields.map((field, index) => (
            <div key={field?.id} className="flex  gap-4 items-start">

              {/* Title */}
              <div className="w-[15%]">
                <input
                  {...register(`tasks.${index}.title`, {
                    required: "Title is required",
                  })}
                  placeholder="Enter task title..."
                  className="w-full p-2 border rounded"
                />
                {errors?.tasks?.[index]?.title && (
                  <p className="text-red-500 text-xs mt-1">
                    {errors.tasks[index].title.message}
                  </p>
                )}
              </div>

              {/* Description */}
              <div className="flex-1 min-w-[250px]">
                <textarea
                  {...register(`tasks.${index}.description`, {
                    required: "Description is required",
                  })}
                  placeholder="Enter task description..."
                  className="w-full p-2 border rounded h-[40px]"
                />
                {errors?.tasks?.[index]?.description && (
                  <p className="text-red-500 text-xs mt-1">
                    {errors.tasks[index].description.message}
                  </p>
                )}
              </div>

              {/* Project Dropdown */}
<div className="w-[13%]">
  <select
    {...register(`tasks.${index}.project_id`, { required: "Project is required" })}
    className="w-full p-2 border rounded"
  >
    <option value="">Select Project</option>
    {projects.map((proj) => (
      <option key={proj._id} value={proj._id}>{proj.title}</option>
    ))}
  </select>
  {errors?.tasks?.[index]?.project_id && (
    <p className="text-red-500 text-xs mt-1">{errors.tasks[index].project_id.message}</p>
  )}
</div>

              {/* Assigned By */}
              <div className="w-[12%]">
                <select
                  {...register(`tasks.${index}.assignedBy`, {
                    required: "Assigned By is required",
                  })}
                  className="w-full p-2 border rounded"
                >
                  <option value="">Select Employee</option>
                  {employees.map((emp) => (
                    <option key={emp?._id} value={emp?._id}>
                      {emp?.name}
                    </option>
                  ))}
                </select>
                {errors?.tasks?.[index]?.assignedBy && (
                  <p className="text-red-500 text-xs mt-1">
                    {errors.tasks[index].assignedBy.message}
                  </p>
                )}
              </div>

              {/* Assigned To (only if multi mode) */}
              {showEmployeeField && (
                <div className="w-[12%]">
                  <select
                    {...register(`tasks.${index}.assignedTo`, {
                      required: "Assigned To is required",
                    })}
                    className="w-full p-2 border rounded"
                  >
                    <option value="">Select Employee</option>
                    {employees.map((emp) => (
                      <option key={emp?._id} value={emp?._id}>
                        {emp?.name}
                      </option>
                    ))}
                  </select>
                  {errors?.tasks?.[index]?.assignedTo && (
                    <p className="text-red-500 text-xs mt-1">
                      {errors.tasks[index].assignedTo.message}
                    </p>
                  )}
                </div>
              )}

              {/* Priority */}
              <div className="w-[8%]">
                <select
                  {...register(`tasks.${index}.priority`, {
                    required: "Priority is required",
                  })}
                  className="w-full p-2 border rounded"
                >
                  <option value="">-Select-</option>
                  {priorityOptions.map((opt) => (
                    <option key={opt.value} value={opt.value}>
                      {opt.label}
                    </option>
                  ))}
                </select>
                {errors?.tasks?.[index]?.priority && (
                  <p className="text-red-500 text-xs mt-1">
                    {errors.tasks[index].priority.message}
                  </p>
                )}
              </div>

              {/* Status */}
              <div className="w-[10%]">
                <select
                  {...register(`tasks.${index}.status`, {
                    required: "Status is required",
                  })}
                  className="w-full p-2 border rounded"
                >
                  <option value="">Select Status</option>
                  <option value="to-do">To-Do</option>
                  <option value="pending">Pending</option>
                  <option value="hold">Hold</option>
                  <option value="in-progress">In Progress</option>
                  <option value="completed">Completed</option>
                </select>
                {errors?.tasks?.[index]?.status && (
                  <p className="text-red-500 text-xs mt-1">
                    {errors.tasks[index].status.message}
                  </p>
                )}
              </div>

              {/* Start Date */}
              <div className="w-[10%]">
                <input
                  type="date"
                  {...register(`tasks.${index}.startDate`, {
                    required: "Start Date is required",
                  })}
                  className="w-full p-2 border rounded"
                  min={getTodayDate()}
                />
                {errors?.tasks?.[index]?.startDate && (
                  <p className="text-red-500 text-xs mt-1">
                    {errors.tasks[index].startDate.message}
                  </p>
                )}
              </div>

              {/* End Date */}
              <div className="w-[10%]">
                <input
                  type="date"
                  {...register(`tasks.${index}.endDate`, {
                    required: "End Date is required",
                  })}
                  className="w-full p-2 border rounded"
                  min={getTodayDate()}
                />
                {errors?.tasks?.[index]?.endDate && (
                  <p className="text-red-500 text-xs mt-1">
                    {errors.tasks[index].endDate.message}
                  </p>
                )}
              </div>

              {/* Remove button */}
              <div className="w-[7%] flex justify-center pt-2">
                <button
                  type="button"
                  onClick={() => remove(index)}
                  disabled={fields.length <= 1}
                  className="text-red-500 hover:text-red-600"
                >
                  <Trash2 />
                </button>
              </div>
            </div>
          ))}
        </div>

      </div>

      {/* Footer */}
      <div className="flex justify-end items-center mt-6 pt-4 border-t gap-3">
        <button
          type="button"
          onClick={() =>
            append({
              title: "",
              description: "",
              assignedBy: "",
              assignedTo: "",
              startDate: getTodayDate(),
              endDate: getTodayDate(),
              status: "",
              priority: "",
              createdBy: "68c15ce1855dbd716909c257",
              project_id: "",
              })
          }
          className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-200 rounded"
        >
          + Add New Task
        </button>
        <button
          type="submit"
          disabled={isLoading}
          className="px-6 py-2 text-sm font-medium text-white bg-[#2C4E86] rounded"
        >
          {isLoading ? "Submitting..." : `Submit ${fields.length} Task(s)`}
        </button>
      </div>
    </form>
  );
};
